/* eslint-disable max-params */
/* eslint-disable max-nested-callbacks */
import $ from 'jquery';
import { SDK } from '@ringcentral/sdk';
import 'bootstrap/dist/css/bootstrap.min.css';
import type Platform from '@ringcentral/sdk/lib/platform/Platform';
import { SessionState } from 'sip.js';

import WebPhone from '../src/index';
import incomingAudio from 'url:./audio/incoming.ogg';
import outgoingAudio from 'url:./audio/outgoing.ogg';

import phoneIcon from 'url:./image/phone@2x.png';
import hangUpIcon from 'url:./image/hangUp@2x.png';

import videoOpenIcon from 'url:./image/video-open@2x.png';
import videoCloseIcon from 'url:./image/video-close@2x.png';
import volumeOpenIcon from 'url:./image/volume-open@2x.png';
import volumeCloseIcon from 'url:./image/volume-close@2x.png';
import upIcon from 'url:./image/up@2x.png';
import downIcon from 'url:./image/down@2x.png';
import signalIcon from 'url:./image/signal-4@2x.png';

import type { WebPhoneInvitation } from '../src/session';
global.jQuery = $;
import('bootstrap');

//'eMSPzZBhevIb6swoXb2heOZYgUrevXtbScIb3fsHQ67d'

$(() => {
    let sdk: SDK;
    let platform: Platform;
    let webPhone: WebPhone;

    let logLevel: 0 | 1 | 2 | 3 = 0;
    let extension: any;
    let primaryNumber: string;
    let toNumber: string;
    let clientSecret: string;
    let lang: string = 'en';
    let callAnswered: boolean = false;
    let audioVolume: number = 0.3;

    // const $incomingTemplate = $('#template-incoming');
    // const $acceptedTemplate = $('#template-accepted');
    // const $connectingTemplate = $('#template-connecting');

    // 在文件顶部添加语言包定义
    const languagePack = {
      en: {
        connecting: 'Connecting ...',
        end_call: 'End call'
      },
      zh: {
        connecting: '呼叫中...',
        end_call: '结束通话'
      },
      es: {
        connecting: 'Conectando...',
        end_call: 'Finalizar llamada'
      }
      // 可以继续添加其他语言
    };

    const $incomingTemplate = '';

    const $acceptedTemplate = $('<!-- 接听中 -->\n' +
        '<div class="newline-container">\n' +
        '                <div class="newline">\n' +
        '                    <span class="newline-text">Newline</span>\n' +
        '                </div>\n' +
        '                <div>\n' +
        '                    <div id="call-timer2" class="call-timer-wrapper">\n' +
        '                        <span id="call-timer-text" class="call-timer-text">00:00</span>\n' +
        '                        <img style="width: 40px; height: 40px" src="image/signal-4@2x.png" class="call-timer-img">\n' +
        '                    </div>\n' +
        '                </div>\n' +
        '            </div>\n' +
        '\n' +
        '        <div class="accepted-btn">\n' +
        '            <img id="video-btn" style="width: 49px; height: 48px" src="image/video-open@2x.png">\n' +
        '            <div class="custom-select-container">\n' +
        '                    <div class="select-trigger" id="custom-mic-trigger">\n' +
        '                        <img class="arrow-icon" style="width: 25px; height: 24px" src="image/up@2x.png">\n' +
        '                    </div>\n' +
        '                    <div class="select-dropdown" id="custom-mic-dropdown">\n' +
        '                    </div>\n' +
        '                </div>\n' +
        '            <img id="volume-btn" style="width: 49px; height: 48px" src="image/volume-open@2x.png">\n' +
        '            <div class="custom-select-container">\n' +
        '                    <div class="select-trigger" id="custom-spk-trigger">\n' +
        '                        <img class="arrow-icon" style="width: 25px; height: 24px" src="image/up@2x.png">\n' +
        '                    </div>\n' +
        '                    <div class="select-dropdown" id="custom-spk-dropdown">\n' +
        '                    </div>\n' +
        '                </div>\n' +
        '            <div id="end-button" class="end-button">\n' +
        '                <img src="image/hangUp@2x.png" alt="Hang Up" class="end-button-icon">\n' +
        '                <span class="button-text">End call</span>\n' +
        '            </div>\n' +
        '        </div>');

    const $connectingTemplate = $('<!-- 呼叫中 -->\n' +
        '        <div class="text">\n' +
        '            <img style="width: 48px; height: 48px" src="image/phone@2x.png" alt="icon" class="text-icon">\n' +
        '            <span class="text-content">Connecting ...</span>\n' +
        '        </div>\n' +
        '\n' +
        '        <div class="button">\n' +
        '            <img style="width: 48px; height: 48px" src="image/hangUp@2x.png" alt="Hang Up" class="button-icon">\n' +
        '            <span class="button-text">End call</span>\n' +
        '        </div>');

    const remoteVideoElement = document.getElementById('remoteVideo') as HTMLMediaElement;
    const localVideoElement = document.getElementById('localVideo') as HTMLMediaElement;
    let outboundCall = true;
    let confSessionId = '';

    // 添加获取本地化文本的函数
    function getLocalizedText(key: string): string {
      return languagePack[lang]?.[key] || languagePack['en'][key] || key;
    }

    // 获取浏览器地址栏参数
    function getUrlParams(): URLSearchParams {
        return new URLSearchParams(window.location.search);
    }

    // 示例：获取特定参数
    function getParam(paramName: string): string | null {
        const params = getUrlParams();
        return params.get(paramName);
    }

    // 示例：获取所有参数并打印到控制台
    function logAllParams(): void {
        const params = getUrlParams();
        console.log('URL Parameters:');
        for (const [key, value] of params.entries()) {
            console.log(`${key}: ${value}`);
        }
    }

    // 获取特定参数示例（例如 ?username=john 或 ?phone=123456789）
    const username = getParam('username');
    const phone = getParam('phone');

    if (username) {
        console.log('Username from URL:', username);
    }

    if (phone) {
        console.log('Phone from URL:', phone);
    }

    //初始化
    function init(){
        logAllParams();

        //获取语言参数和号码参数
        lang = getParam('hl');
        toNumber = getParam('tonumber');

        console.log('lang:', lang);
        console.log('tonumber:', toNumber);
        if(!toNumber){
            console.log('tonumber cannot be empty');
            closeModal('011')
            return;
        }

        //获取clientSecret参数
        clientSecret = getParam('clientSecret');
        if(!clientSecret){
            console.log('clientSecret cannot be empty');
            closeModal('012')
            return;
        }

        // const $modal = cloneTemplate($connectingTemplate);
        const $modal = $connectingTemplate;

        // 替换特定图片
        $modal.find('img[src*="image/phone@2x.png"]').attr('src', phoneIcon);
        $modal.find('img[src*="image/hangUp@2x.png"]').attr('src', hangUpIcon);

        // 添加本地化文本替换
        $modal.find('.text-content').text(getLocalizedText("connecting"));
        $modal.find('.button-text').text(getLocalizedText("end_call"));

        const $container = $('#container');
        $container.attr('class', 'container');
        $container.empty(); // 清空现有内容
        $container.append($modal);

        $container.find('.button').on('click', () => {
            //接通之前挂断
            closeModal('001');
        });

        login('https://platform.ringcentral.com',
            'WVxchVjor3YdQgnFAsqhWx',
            clientSecret,
            'eyJraWQiOiI4NzYyZjU5OGQwNTk0NGRiODZiZjVjYTk3ODA0NzYwOCIsInR5cCI6IkpXVCIsImFsZyI6IlJTMjU2In0.eyJhdWQiOiJodHRwczovL3BsYXRmb3JtLnJpbmdjZW50cmFsLmNvbS9yZXN0YXBpL29hdXRoL3Rva2VuIiwic3ViIjoiNjI3ODQxNjUwMDYiLCJpc3MiOiJodHRwczovL3BsYXRmb3JtLnJpbmdjZW50cmFsLmNvbSIsImV4cCI6MzkwNjUyOTM1MiwiaWF0IjoxNzU5MDQ1NzA1LCJqdGkiOiIyWGRtbEkteVJsYTBfUUczX2w3cWZ3In0.PMykkuH3Ad4d_J7XLRDYJQRQNpoGP6R1UC7iX7cWySqILs9ksvjFR-sipzSwrbOy-z7-XdzVQWCYzGQKhgvivZJ2Fr078j-tvdPWAcxKOClGmtBGmq9wKKWmyDvcQKu5GhR1VKG9Cc1Hgx-kav2V7JqBgwzNhk0XPz1xfQCnoO-H0R9z4zJOPhILLEva_8jX8ULOmb744tXllOeCbF6YNEMdmh1a226rv1qIcvPqWqdtSLt6lcvVtugCMhyfEi4bxZfALQx1Ns9vcQm-O1kTS-QvZcJHdY9yRt5qpXJAb1LSse9alWkaJd-W3LYOmeFjiIRCOdx3wHpVeoPoP-wENw',
            logLevel);
    }

    /**
     * @param {jQuery|HTMLElement} $tpl
     * @return {jQuery|HTMLElement}
     */
    function cloneTemplate($tpl) {
        return $($tpl.html());
    }

    // 登录
    function login(server, clientId, clientSecret, jwtToken, ll) {
        sdk = new SDK({
            clientId,
            clientSecret,
            server,
        });

        platform = sdk.platform();

        platform
            .login({
                jwt: jwtToken,
            })
            .then(() => {
                return postLogin(server, clientId, clientSecret, jwtToken, ll);
            })
            .catch((e) => {
                console.error(e.stack || e);
            });
    }

    // 登录成功后执行
    function postLogin(server, clientId, clientSecret, jwtToken, ll) {
        logLevel = ll;

        localStorage.setItem('webPhoneServer', server || '');
        localStorage.setItem('webPhoneclientId', clientId || '');
        localStorage.setItem('webPhoneclientSecret', clientSecret || '');
        if (jwtToken && jwtToken.length > 0) {
            localStorage.setItem('webPhoneJwtToken', jwtToken);
        }
        localStorage.setItem('webPhoneLogLevel', (logLevel || 0).toString());

        return platform
            .get('/restapi/v1.0/account/~/extension/~')
            .then((res) => res.json())
            .then((res) => {
                extension = res;
                console.log('Extension info', extension);
                return platform.get('/restapi/v1.0/account/~/extension/~/phone-number');
            })
            .then((res) => res.json())
            .then((r) => {
                primaryNumber = r.records.filter((r) => r.primary === true)[0].phoneNumber;
            })
            .then(() => {
                return platform.post('/restapi/v1.0/client-info/sip-provision', {
                    sipInfo: [
                        {
                            transport: 'WSS',
                        },
                    ],
                });
            })
            .then((res) => res.json())
            .then(register)
            // .then(makeCallForm)
            .catch((e) => {
                console.error('Error in main promise chain');
                console.error(e.stack || e);
            });
    }

    // 初始化WebPhone
    function register(data) {
        webPhone = new WebPhone(data, {
            enableDscp: true,
            clientId: localStorage.getItem('webPhoneclientId')!,
            audioHelper: {
                enabled: true,
                // incoming: incomingAudio,
                outgoing: outgoingAudio,
            },
            logLevel,
            appName: 'WebPhoneDemo',
            appVersion: '1.0.0',
            media: {
                remote: remoteVideoElement,
                local: localVideoElement,
            },
            enableQos: true,
            enableMediaReportLogging: true,
        });
        global.webPhone = webPhone; // for debugging

        webPhone.userAgent.audioHelper.setVolume(audioVolume);
        // webPhone.userAgent.on('invite', onInvite);
        webPhone.userAgent.on('connecting', () => {
            console.log('UA connecting');
        });
        webPhone.userAgent.on('connected', () => {
            console.log('UA Connected');
        });
        webPhone.userAgent.on('disconnected', () => {
            console.log('UA Disconnected');
        });
        webPhone.userAgent.on('registered', () => {
            console.log('UA Registered');

            makeCall(toNumber, 1);
        });
        webPhone.userAgent.on('unregistered', () => {
            console.log('UA Unregistered');
        });
        webPhone.userAgent.on('registrationFailed', function () {
            console.log('UA RegistrationFailed', arguments);
        });
        webPhone.userAgent.on('message', function () {
            console.log('UA Message', arguments);
        });
        webPhone.userAgent.transport.on('switchBackProxy', () => {
            console.log('switching back to primary outbound proxy');
            webPhone.userAgent.transport.reconnect();
        });
        webPhone.userAgent.transport.on('closed', () => {
            console.log('WebSocket closed.');
        });
        webPhone.userAgent.transport.on('transportError', () => {
            console.log('WebSocket transportError occured');
        });
        webPhone.userAgent.transport.on('wsConnectionError', () => {
            console.log('WebSocket wsConnectionError occured');
        });
        return webPhone;
    }

    // 监听会话状态
    function onAccepted(session) {
        // 添加通话建立标志
        callAnswered = false;
        session.stateChange.addListener((newState: SessionState) => {
            switch (newState) {
                case SessionState.Initial: {
                    console.log('Initial');
                    break;
                }
                case SessionState.Establishing: {
                    //创建会话
                    console.log('Establishing');
                    break;
                }
                case SessionState.Established: {
                    //呼叫双方成功连接
                    callAnswered = true;
                    console.log('Established');
                    activeCallInfo(session);
                    break;
                }
                case SessionState.Terminating: {
                    //会话结束中
                    console.log('Terminating');
                    closeModal('003');
                    break;
                }
                case SessionState.Terminated: {
                    console.log('Terminated');
                    if (callAnswered) {
                        //接通后，对方挂断或自己挂断
                        closeModal('002');
                        localStorage.setItem('activeCallInfo', '');
                    }else {
                        // 没有扬声器或拒绝音频设备授权，自动挂断
                        closeModal('006');
                    }

                    // 在会话终止时停止计时器
                    stopCallTimer();
                    // 停止轮询
                    clearInterval(pollInterval);
                    break;
                }
            }
        });

        session.on('refer', () => {
            // 转接
            console.log('Event: Refer');
            closeModal('004');
        });
        session.on('replaced', (newSession) => {
            // 接听新来电
            console.log('Event: Replaced: old session', session, 'has been replaced with', newSession);
            closeModal('005');
            onAccepted(newSession);
        });
        session.on('dtmf', () => {
            console.log('Event: DTMF');
        });
        session.on('muted', () => {
            console.log('Event: Muted');
        });
        session.on('unmuted', () => {
            console.log('Event: Unmuted');
        });
    }

    // 呼叫
    function makeCall(number, homeCountryId) {
        outboundCall = true;
        // eslint-disable-next-line no-param-reassign
        homeCountryId = homeCountryId || extension?.regionalSettings?.homeCountry?.id || null;

        const session = webPhone.userAgent.invite(number, {
            fromNumber: primaryNumber,
            homeCountryId,
        });

        onAccepted(session);
    }

    // 接听
    function activeCallInfo(session) {
        console.log('EVENT: Accepted', session.request);
        console.log('To', session.request.to.displayName, session.request.to.friendlyName);
        console.log('From', session.request.from.displayName, session.request.from.friendlyName);

        // const $modal = cloneTemplate($acceptedTemplate);
        const $modal = $acceptedTemplate;

        // 替换特定图片
        $modal.find('img[src*="image/video-open@2x.png"]').attr('src', videoOpenIcon);
        $modal.find('img[src*="image/up@2x.png"]').attr('src', upIcon);
        $modal.find('img[src*="image/volume-open@2x.png"]').attr('src', volumeOpenIcon);
        $modal.find('img[src*="image/down@2x.png"]').attr('src', upIcon);
        $modal.find('img[src*="image/hangUp@2x.png"]').attr('src', hangUpIcon);
        $modal.find('img[src*="image/signal-4@2x.png"]').attr('src', signalIcon);

        // 添加本地化文本替换
        $modal.find('.button-text').text(getLocalizedText("end_call"));

        const $container = $('#container');
        $container.attr('class', '');
        $container.empty(); // 清空现有内容
        $container.append($modal);

        // 挂断
        $container.find('#end-button').on('click', () => {
            console.log('session.dispose()')
            session.dispose();
        });

        // 静音
        $container.find('#video-btn').on('click', () => {
            const video = $('#video-btn');
            console.log(video.attr('src'))
            if(video.attr('src') === videoOpenIcon){
                console.log('open：click')
                video.attr('src', videoCloseIcon);
                session.mute();
            }else {
                console.log('close：click')
                video.attr('src', videoOpenIcon);
                session.unmute();
            }
        });

        // $container.find('#volume-btn').on('click', () => {
        //     const volume = $('#volume-btn');
        //     console.log(volume.attr('src'))
        //     if(volume.attr('src') === volumeOpenIcon){
        //         console.log('open：click')
        //         volume.attr('src', volumeCloseIcon);
        //         // 设置扬声器静音
        //         session.userAgent.audioHelper.setVolume(0);
        //     }else {
        //         console.log('close：click')
        //         volume.attr('src', volumeOpenIcon);
        //         // 恢复扬声器音量
        //         session.userAgent.audioHelper.setVolume(audioVolume);
        //     }
        // });

        // 启动计时器
        startCallTimer();

        // 获取并显示音频设备列表
        getAudioDevices().then(({ audioInputDevices, audioOutputDevices }) => {
            // 创建设备选择下拉菜单
            createDeviceSelector(audioInputDevices, audioOutputDevices, session);
            // 轮询检查设备变化
            setupDevicePolling();
        });
    }

    // 结束通话
    function closeModal(code){
        window.location.href = 'end.html?code=' + code;
    }

    // 获取音频设备列表
    async function getAudioDevices() {
        try {
            // 请求媒体权限以获取设备列表
            // const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            // 获取设备列表
            const devices = await navigator.mediaDevices.enumerateDevices();

            // 释放媒体流
            // stream.getTracks().forEach(track => track.stop());

            // 分离输入和输出设备
            const audioInputDevices = devices.filter(device => device.kind === 'audioinput');
            const audioOutputDevices = devices.filter(device => device.kind === 'audiooutput');

            return { audioInputDevices, audioOutputDevices };
        } catch (error) {
            console.error('获取音频设备失败:', error);
            return { audioInputDevices: [], audioOutputDevices: [] };
        }
    }

    // 设置当前通话使用的音频设备
    async function setAudioDevice(session: any, deviceId: string, deviceType: 'input' | 'output') {
        try {
            if (deviceType === 'input') {
                // 设置麦克风设备
                const constraints = {
                    audio: {
                        deviceId: deviceId ? { exact: deviceId } : undefined
                    }
                };

                // 重新获取媒体流并应用到会话
                const stream = await navigator.mediaDevices.getUserMedia(constraints);

                // 应该使用 session 的方法来更新媒体流
                if (session.sessionDescriptionHandler) {
                    // 先释放旧的媒体流
                    if (session.sessionDescriptionHandler.localMediaStream) {
                        session.sessionDescriptionHandler.localMediaStream.getTracks().forEach(track => track.stop());
                    }

                    // 使用正确的方式设置新的媒体流
                    session.sessionDescriptionHandler.setLocalMediaStream(stream);
                }
            } else if (deviceType === 'output' && 'setSinkId' in HTMLMediaElement.prototype) {
                // 设置扬声器设备（需要浏览器支持）
                const remoteVideoElement = document.getElementById('remoteVideo') as HTMLMediaElement;
                if (remoteVideoElement) {
                    await (remoteVideoElement as any).setSinkId(deviceId);
                }
            }

            console.log(`成功设置${deviceType === 'input' ? '麦克风' : '扬声器'}设备`);
        } catch (error) {
            console.error(`设置${deviceType === 'input' ? '麦克风' : '扬声器'}设备失败:`, error);
        }
    }

    // 创建设备选择器UI
    function createDeviceSelector(inputDevices: MediaDeviceInfo[], outputDevices: MediaDeviceInfo[], session: any) {
        console.log('inputDevices:', inputDevices);
        console.log('outputDevices:', outputDevices);

        // 麦克风设备排序 - 按名称字母顺序
        inputDevices.sort((a, b) => {
            // 如果设备标签包含"default"或"default"相关词汇，则优先显示
            const isDefaultA = a.deviceId?.toLowerCase().includes('default') ? 0 : 1;
            const isDefaultB = b.deviceId?.toLowerCase().includes('default') ? 0 : 1;

            if (isDefaultA !== isDefaultB) {
                return isDefaultA - isDefaultB;
            }

            return a.groupId.localeCompare(b.groupId);
        });

        // 扬声器设备排序 - 按名称字母顺序
        outputDevices.sort((a, b) => {
            // 如果设备标签包含"default"或"default"相关词汇，则优先显示
            const isDefaultA = a.deviceId?.toLowerCase().includes('default') ? 0 : 1;
            const isDefaultB = b.deviceId?.toLowerCase().includes('default') ? 0 : 1;

            if (isDefaultA !== isDefaultB) {
                return isDefaultA - isDefaultB;
            }

            return a.groupId.localeCompare(b.groupId);
        });

        // 创建麦克风选择器
        const micSelector = $('#custom-mic-dropdown');
        micSelector.empty(); // 清空现有内容
        inputDevices.forEach((device, index) => {
            //<div class="select-option" data-value="mic1">2</div>
            console.log(device.label)
            const optionHtml = `<div class="select-option${index === 0 ? ' selected' : ''}" data-value="${device.deviceId}">${device.label || `mic ${device.deviceId.substr(0, 10)}`}</div>`;
            micSelector.append(optionHtml);
        });

        // 创建扬声器选择器
        const speakerSelector = $('#custom-spk-dropdown');
        speakerSelector.empty(); // 清空现有内容
        outputDevices.forEach((device, index) => {
            //<div class="select-option" data-value="mic1">2</div>
            console.log(device.label)
            const optionHtml = `<div class="select-option${index === 0 ? ' selected' : ''}" data-value="${device.deviceId}">${device.label || `spk ${device.deviceId.substr(0, 10)}`}</div>`;
            speakerSelector.append(optionHtml);
        });

        initCustomSelect();

        // 为选项添加点击事件处理
        $('.select-option').off('click').on('click', function() {
            const deviceId = $(this).attr('data-value');
            const dropdown = $(this).closest('.select-dropdown');
            const isMic = dropdown.attr('id') === 'custom-mic-dropdown';

            if (isMic) {
                console.log('click：mic' + deviceId)
                setAudioDevice(session, deviceId, 'input');
            } else {
                console.log('click：spk' + deviceId)
                setAudioDevice(session, deviceId, 'output');
            }
        });

    }

    let pollInterval = null;
    // 轮询检查设备变化
    function setupDevicePolling() {
        let previousDevices: MediaDeviceInfo[] = [];

        pollInterval = setInterval(async () => {
            try {
                const devices = await navigator.mediaDevices.enumerateDevices();
                const currentDevices = devices.filter(d => d.kind === 'audioinput' || d.kind === 'audiooutput');

                // 比较设备列表是否有变化
                if (hasDeviceListChanged(previousDevices, currentDevices)) {
                    console.log('通过轮询检测到设备变化');
                    const { audioInputDevices, audioOutputDevices } = await getAudioDevices();
                    updateDeviceSelectors(audioInputDevices, audioOutputDevices);
                    previousDevices = currentDevices;
                }
            } catch (error) {
                console.error('轮询检查设备时出错:', error);
            }
        }, 3000); // 每3秒检查一次

        // 在适当的时候清除轮询
        // clearInterval(pollInterval);
    }

    // 检查设备列表是否发生变化
    function hasDeviceListChanged(oldDevices: MediaDeviceInfo[], newDevices: MediaDeviceInfo[]): boolean {
        if (oldDevices.length !== newDevices.length) {
            return true;
        }

        // 检查设备ID和标签是否相同
        for (let i = 0; i < oldDevices.length; i++) {
            if (oldDevices[i].deviceId !== newDevices[i].deviceId ||
                oldDevices[i].label !== newDevices[i].label) {
                return true;
            }
        }

        return false;
    }

    // 更新设备选择器
    function updateDeviceSelectors(inputDevices: MediaDeviceInfo[], outputDevices: MediaDeviceInfo[]) {
        // 创建麦克风选择器
        const micSelector = $('#custom-mic-dropdown');
        const speakerSelector = $('#custom-spk-dropdown');

        micSelector.empty(); // 清空现有内容
        speakerSelector.empty(); // 清空现有内容

        inputDevices.forEach((device, index) => {
            const optionHtml = `<div class="select-option${index === 0 ? ' selected' : ''}" data-value="${device.deviceId}">${device.label || `mic ${device.deviceId.substr(0, 10)}`}</div>`;
            micSelector.append(optionHtml);
        });

        // 创建扬声器选择器
        outputDevices.forEach((device, index) => {
            const optionHtml = `<div class="select-option${index === 0 ? ' selected' : ''}" data-value="${device.deviceId}">${device.label || `spk ${device.deviceId.substr(0, 10)}`}</div>`;
            speakerSelector.append(optionHtml);
        });
    }

    // 添加通话计时器相关变量
    let callStartTime: Date | null = null;
    let callTimerInterval: number | null = null;

    // 启动通话计时器
    function startCallTimer() {
        callStartTime = new Date();

        callTimerInterval = window.setInterval(() => {
            updateCallTimerDisplay();
        }, 1000);
    }

    // 更新计时器显示
    function updateCallTimerDisplay() {
        if (!callStartTime) return;

        const now = new Date();
        const elapsedSeconds = Math.floor((now.getTime() - callStartTime.getTime()) / 1000);
        const minutes = Math.floor(elapsedSeconds / 60);
        const seconds = elapsedSeconds % 60;

        const timerText = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        $('#call-timer-text').text(timerText);
    }

    // 停止计时器
    function stopCallTimer() {
        if (callTimerInterval) {
            clearInterval(callTimerInterval);
            callTimerInterval = null;
        }
        callStartTime = null;
    }

    function initCustomSelect() {
        const triggers = document.querySelectorAll('.select-trigger');

        triggers.forEach(trigger => {
            const dropdown = trigger.nextElementSibling;
            // const selectedText = trigger.querySelector('.selected-text');
            const arrowIcon = trigger.querySelector('.arrow-icon');

            // 点击触发器显示/隐藏下拉菜单
            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                closeAllDropdowns(dropdown);
                dropdown.classList.toggle('show');
                arrowIcon.classList.toggle('rotated');
            });

            // 点击选项
            const options = dropdown.querySelectorAll('.select-option');
            options.forEach(option => {
                option.addEventListener('click', (e) => {
                    e.stopPropagation();

                    // 更新选中状态
                    options.forEach(opt => opt.classList.remove('selected'));
                    option.classList.add('selected');

                    // 更新显示文本
                    // selectedText.textContent = option.textContent;

                    // 隐藏下拉菜单
                    dropdown.classList.remove('show');
                    arrowIcon.classList.remove('rotated');

                    // 触发自定义事件
                    const event = new CustomEvent('customSelectChange', {
                        detail: {
                            value: option.getAttribute('data-value') || '',
                            text: option.textContent
                        }
                    });
                    trigger.dispatchEvent(event);
                });
            });
        });

        // 点击外部关闭下拉菜单
        document.addEventListener('click', () => {
            closeAllDropdowns(null);
        });
    }

    function closeAllDropdowns(except) {
        const dropdowns = document.querySelectorAll('.select-dropdown');
        dropdowns.forEach(dropdown => {
            if (dropdown !== except) {
                dropdown.classList.remove('show');
                const trigger = dropdown.previousElementSibling;
                const arrowIcon = trigger.querySelector('.arrow-icon');
                arrowIcon.classList.remove('rotated');
            }
        });
    }

    // 初始化自定义下拉选择
    document.addEventListener('DOMContentLoaded', () => {
        initCustomSelect();
    });

    init();
});
